import { CmsSignInForm } from './cms-sign-in-form.interface';

export interface CmsSignIn extends CmsSignInForm {
  signInButtonLabel: string;
  signInDescription: string;
  signInTitle: string;
}
